<template>
    <div>
        <!-- 表格 -->
        <el-table class="columnClassNav" align="center" :data="tableData" border>
            <el-table-column label="用户id" prop="userid" align="center">
            </el-table-column>

            <el-table-column label="用户昵称" prop="nickName" align="center">
                <template slot-scope="tableData">
                    {{ nickName || '--' }}
                </template>
            </el-table-column>

            <el-table-column label="变动数量" prop="changeAmount" align="center">
                <template slot-scope="tableData">
                    <span :style="{ color: tableData.row.type == 'INCREASE' ? '#5eb95e' : '#f04134' }">
                        <span>{{ tableData.row.type == 'INCREASE' ? '+' : '-' }}</span>
                        <span>{{ tableData.row.changeAmount }}</span>
                    </span>
                </template>
            </el-table-column>

            <el-table-column label="余额变动业务" prop="changeAmount" align="center">
                <template slot-scope="tableData">
                    <el-tag>
                        {{ tableData.row.sourceType == 'RECHARGE' ? '充值' : tableData.row.sourceType == 'WITHDRAW' ? '提现'
                            : tableData.row.sourceType == 'GIFT' ? '赠送礼物' : tableData.row.sourceType == 'RECEIVE_GIFT' ?
                        '接收礼物' : tableData.row.sourceType == 'SYSTEM_OPERATE' ? '系统操作' : '未知' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="变动前余额" align="center" prop="beforeAmount">
            </el-table-column>

            <el-table-column prop="afterAmount" label="变动后余额" align="center">
            </el-table-column>

            <el-table-column prop="createTime" label="变动时间" align="center">
            </el-table-column>
        </el-table>

        <div style="text-align: right;margin: 20px 20px 0 0;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="params.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="total_pages">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import '@/assets/icon/iconfont.css'
import { getBalanceRecordPage } from '@/api/withdraw'
export default {
    name: 'messageList',
    props: {
        userId: { type: Number, default: 0 },
        nickName: { type: String, default: '' },
    },
    data() {
        return {
            tableData: '',
            // 对话框
            total_pages: 0,
            params: { pageNum: 1, pageSize: 10 },
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            this.params.userid = this.userId;
            getBalanceRecordPage(this.params).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data.records;
                    this.total_pages = res.data.total;
                } else {
                    this.$message.error(res.msg || '获取礼物记录列表失败');
                }
            }).catch((err) => {
                this.$message.error(err ? err : '获取礼物记录列表失败');
            })
        },
        handleCurrentChange(number) {
            this.params.pageNum = number;
            this.getData();
        },
        handleSizeChange(size) {
            if (this.total_pages >= size) {
                this.params.pageSize = size;
                this.getData();
            }
        }
    }
}
</script>

<style scoped lang="scss">
.elTableBox {
    display: flex;
    width: 100%;
}
</style>
